import { render, staticRenderFns } from "./27.vue?vue&type=template&id=32803844&scoped=true&"
import script from "./27.vue?vue&type=script&lang=js&"
export * from "./27.vue?vue&type=script&lang=js&"
import style0 from "./27.vue?vue&type=style&index=0&id=32803844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32803844",
  null
  
)

export default component.exports